import React from 'react';
import PropTypes from 'prop-types';
import { TimeHelpers } from '@arreeba/ristoranti-frontend-lib';

const OrderRecap = (props) => {
  return (
    <div className="orderRecap">
      <div className="orderRecap__el">
        <i className="bi_location-pin" />
        <p>{props.location}</p>
      </div>
      <div className="orderRecap__el">
        <i className="bi_time-clock-a" />
        <p>{TimeHelpers.toHumanDate(props.date, 'it', 'LL')}</p>
      </div>
    </div>
  );
};

OrderRecap.propTypes = {
  date: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
};

export default OrderRecap;



// WEBPACK FOOTER //
// ./src/components/order-recap.js